import { render, staticRenderFns } from "./AndroidDevelopment.vue?vue&type=template&id=608bc9f1&"
import script from "./AndroidDevelopment.vue?vue&type=script&lang=js&"
export * from "./AndroidDevelopment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports